import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/helpers/auth.service';

@Component({
  selector: 'loyaltic-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  isLoggedIn = false;
  
  router: Router
  constructor(private _router: Router, private authService: AuthService) { }

  ngOnInit() {
    if (this.authService.getUserId() !== null) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }

    this.authService.getAuthentication().subscribe((response:any) => {
      this.isLoggedIn = response.isAuthenticated;
    })
  }

}
